<script setup lang="ts">
import { moduleName } from '@/enums/moduleNames';
import { getCachedGuestViewCircleMonthly, getCachedGuestViewCircleSevenDay, getCachedGuestViewCircleYearly, getCachedUserViewCircleMonthly, getCachedUserViewCircleSevenDay, getCachedUserViewCircleYearly } from '@/service/analytics/basicAnalytics';
import { userPermissionStore } from '@/stores/user/permission';
import type { AxiosResponse } from 'axios';
import moment from 'moment';
import { computed, onMounted, reactive, ref, type Ref } from 'vue';
import BarChart from '../charts/barChart.vue';
import linearLoadingCard from '../loading/linearLoadingCard.vue';

interface totalViewRecord {
  total: number, 
  target_date: Date,
  action: string
}

enum period {
  SEVENDAY = 'SEVENDAY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

const periodState = ref<period>(period.SEVENDAY)

interface dataset {
  label: string,
  data: number[],
  backgroundColor: string
}

var sortableCount = 2
const periodCounter = ref<number>(0)

const chartData = reactive({
  labels: [] as string[],
  circleDataUser: {label: 'Has Signed In', data: [], backgroundColor: '#8AB8F5', maxBarThickness: 50} as dataset,
  circleDataNonUser: {label: 'Not SIgned In', data: [], backgroundColor: '#4198D3', maxBarThickness: 50} as dataset,
})

// const dataSets = ref<dataset[]>([])
// const labels = ref<string[]>([])

// // const researchCollection = ref<{label: string, value: number}[]>([])
// // const institutionCollection = ref<{label: string, value: number}[]>([])

// interface mergedData {
//   label:string[]
//   mergedData: number[]
// }

const userPermission = userPermissionStore()

// const totalViewNonUserResearch = ref<totalViewRecord[]>([])
// const totalViewUserResearch = ref<totalViewRecord[]>([])
const totalViewUserCircle = ref<totalViewRecord[]>([])
const totalViewNonUserCircle = ref<totalViewRecord[]>([])
// const totalViewMergedResearch = ref<totalViewRecord[]>([])
// const totalViewMergedCircle = ref<totalViewRecord[]>([])

const fetchState = reactive({
  // fetchingTotalViewSignedInUserForResearchInSevenDaysBack: true,
  // fetchingTotalViewNonUserForResearchInSevenDaysBack: true,
  fetchingTotalViewSignedInUserForCircleInSevenDaysBack: true,
  fetchingTotalViewNonUserForCircleInSevenDaysBack: true,
  dataSorted: false,
})

// function mergeAll (){
//   for (var x = 0; x < institutionCollection.value.length; x++) {
//     var assigned = false
//     for(var y = 0; y < labels.value.length; y++) {
//       if (moment(labels.value[y]).isBefore(moment(institutionCollection.value[x].label))) {
//         labels.value.push(institutionCollection.value[x].label)
//         chartData.researchDataNonUser.data.push(institutionCollection.value[x].value)
//         assigned = true
//         break
//       } else if (labels.value[y] === institutionCollection.value[x].label) {
//         chartData.researchDataNonUser.data.splice(y-1, 0, institutionCollection.value[x].value)
//         assigned = true
//         break
//       } else if (y === 0 && moment(labels.value[y]).isAfter(moment(institutionCollection.value[x].label))) {
//         chartData.researchDataNonUser.data.unshift(institutionCollection.value[x].value)
//         labels.value.unshift(institutionCollection.value[x].label)
//         assigned = true
//         break
//       }
//     }
//     if (!assigned) {
//       labels.value.push(institutionCollection.value[x].label)
//       chartData.researchDataNonUser.data.push(institutionCollection.value[x].value)
//     }
//   }
// }

// function mergeTotalViewResearch () {
//   if (
//     !fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack && !fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack
//   ) {
//     const data: {label: string, value: number}[] = []

//     for (var x = 0; x < totalViewUserResearch.value.length; x++) {
//       data.push({label: totalViewUserResearch.value[x].target_date.toString(), value: totalViewUserResearch.value[x].total})
//     }

//     for (var y = 0; y < totalViewNonUserResearch.value.length; y++) {
//       var assigned: Boolean = false
//       for(var z = 0; z < data.length; z++) {
//         if (totalViewNonUserResearch.value[y].target_date.toString() === data[z].label) {
//           data[z].value = data[z].value + totalViewNonUserResearch.value[y].total
//           assigned = true
//           break
//         }
//         else if (z === 0 && moment(totalViewNonUserResearch.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.unshift({label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[y].total})
//         }
//         else if (z > 0 && moment(totalViewNonUserResearch.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.splice(z-1, 0, {label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[y].total})
//         }
//       }
//       if (!assigned) {
//         data.push({label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[x].total})
//       }
//     }

//     researchCollection.value = data
//     fetchState.researchPopulated = true
//     if (fetchState.institutionPopulated) {
//       mergeAll()
//     }
//   }
// }
// function mergeTotalViewCircle () {
//   if (
//     !fetchState.fetchingTotalViewNonUserForCircleInSevenDaysBack && !fetchState.fetchingTotalViewSignedInUserForCircleInSevenDaysBack
//   ) {
//     const data: {label: string, value: number}[] = []

//     for (var x = 0; x < totalViewUserCircle.value.length; x++) {
//       data.push({label: totalViewUserCircle.value[x].target_date.toString(), value: totalViewUserCircle.value[x].total})
//     }

//     for (var y = 0; y < totalViewNonUserCircle.value.length; y++) {
//       var assigned: Boolean = false
//       for(var z = 0; z < data.length; z++) {
//         if (totalViewNonUserCircle.value[y].target_date.toString() === data[z].label) {
//           data[z].value = data[z].value + totalViewNonUserCircle.value[y].total
//           assigned = true
//           break
//         }
//         else if (z === 0 && moment(totalViewNonUserCircle.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.unshift({label: totalViewNonUserCircle.value[y].target_date.toString(), value: totalViewNonUserCircle.value[y].total})
//         }
//         else if (z > 0 && moment(totalViewNonUserCircle.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.splice(z-1, 0, {label: totalViewNonUserCircle.value[y].target_date.toString(), value: totalViewNonUserCircle.value[y].total})
//         }
//       }
//       if (!assigned) {
//         data.push({label: totalViewNonUserCircle.value[y].target_date.toString(), value: totalViewNonUserCircle.value[x].total})
//       }
//     }
//     institutionCollection.value = data
//     fetchState.institutionPopulated = true
//     if (fetchState.researchPopulated) {
//       mergeAll()
//     }
//   }
// }

function sortLabelDate (arr: { total: number; target_date: Date; action: string}[], reset: boolean = false) {
  if (reset ) {
    chartData.labels = []
  }
  for (var x = 0; x < arr.length; x++) {
    var assigned = false
    const targetedDate = arr[x].target_date.toString()
    if (chartData.labels.length === 0) {
      chartData.labels.unshift(targetedDate)
      assigned = true
      continue
    }
    if (chartData.labels.includes(targetedDate)) {
      assigned = true
      continue
    }
    if (!assigned) {
      chartData.labels.push(arr[x].target_date.toString())
    }
  }
  sortableCount = sortableCount - 1
  if (sortableCount === 0) {
    chartData.labels.sort((a, b) => moment(a).diff(moment(b), 'days'))
    chartData.circleDataNonUser.data = Array(chartData.labels.length).fill(0)
    chartData.circleDataUser.data = Array(chartData.labels.length).fill(0)
    assignedData(totalViewUserCircle, 'user')
    assignedData(totalViewNonUserCircle, 'nonuser')
    // assignedData(totalViewUserCircle, 'institution')
    // assignedData(totalViewNonUserCircle, 'institution')
    fetchState.dataSorted = true
  }
}

function assignedData (refData: Ref, tag: string = '') {
  for (var x = 0; x < chartData.labels.length; x++) {
    var assigned = false
    for (var y = 0; y < refData.value.length; y++) {
      if (refData.value[y].target_date.toString() === chartData.labels[x]) {
        if (tag === 'user') chartData.circleDataUser.data[x] = chartData.circleDataUser.data[x] + refData.value[y].total
        if (tag === 'nonuser') chartData.circleDataNonUser.data[x] = chartData.circleDataNonUser.data[x] + refData.value[y].total
        assigned = true
        break;
      }
      else if (moment(refData.value[y].target_date).isAfter(moment(chartData.labels[x]))) {
        refData.value.splice(y-1, 0, {total: 0, target_date: moment(chartData.labels[x]).toDate(), action: 'ENTER'})
        assigned =  true
        break;
      }
    }
    if (!assigned) {
      refData.value.push({total: 0, target_date: moment(chartData.labels[x]).toDate(), action: 'ENTER'})
    }
  }
}

const compiledLabel = computed(()=> chartData.labels.map((item:string) => moment(item).format((periodState.value === period.MONTHLY) ? 'MMM YYYY' : ((periodState.value === period.YEARLY) ? 'YYYY' : 'DD MMM YYYY') )))

// async function fetchTotalViewSignedInUserForResearchInSevenDaysBack() {
//   fetchState.fetchingTotalViewSignedInUserForCircleInSevenDaysBack = true
//   const result = (await getTotalViewSignedInUserForResearchInSevenDaysBack())
//   totalViewUserCircle.value = result.data.data
//   sortLabelDate(result.data.data)
//   // totalPublishedNews.value = result.data.data.total
//   fetchState.fetchingTotalViewSignedInUserForCircleInSevenDaysBack = false
// }
// async function fetchTotalViewNonUserForResearchInSevenDaysBack() {
//   fetchState.fetchingTotalViewNonUserForCircleInSevenDaysBack = true
//   const result = (await getTotalViewNonMemberForResearchInSevenDaysBack())
//   totalViewNonUserCircle.value = result.data.data
//   sortLabelDate(result.data.data)
//   // totalPublishedNews.value = result.data.data.total
//   fetchState.fetchingTotalViewNonUserForCircleInSevenDaysBack = false
// }
async function fetchTotalViewSignedInUserForinstitution(targetPeriod: period) {
  fetchState.fetchingTotalViewSignedInUserForCircleInSevenDaysBack = true
  var result = {} as AxiosResponse
  if (targetPeriod === period.SEVENDAY) {
    result = (await getCachedUserViewCircleSevenDay())
  } else if (targetPeriod === period.MONTHLY) {
    result = (await getCachedUserViewCircleMonthly())
  } else if (targetPeriod === period.YEARLY) {
    result = (await getCachedUserViewCircleYearly())
  }
  if (periodState.value === targetPeriod) {
    totalViewUserCircle.value = result.data.data
    periodCounter.value = periodCounter.value + 1
    sortLabelDate(result.data.data, periodCounter.value === 1)
  }
  // totalPublishedNews.value = result.data.data.total
  fetchState.fetchingTotalViewSignedInUserForCircleInSevenDaysBack = false
}
async function fetchTotalViewNonUserForinstitution(targetPeriod: period) {
  fetchState.fetchingTotalViewNonUserForCircleInSevenDaysBack = true
  var result = {} as AxiosResponse
  if (targetPeriod === period.SEVENDAY) {
    result = (await getCachedGuestViewCircleSevenDay())
  } else if (targetPeriod === period.MONTHLY) {
    result = (await getCachedGuestViewCircleMonthly())
  } else if (targetPeriod === period.YEARLY) {
    result = (await getCachedGuestViewCircleYearly())
  }
  if (periodState.value === targetPeriod) {
    totalViewNonUserCircle.value = result.data.data
    periodCounter.value = periodCounter.value + 1
    sortLabelDate(result.data.data, periodCounter.value === 1)
  }
  // totalPublishedNews.value = result.data.data.total
  fetchState.fetchingTotalViewNonUserForCircleInSevenDaysBack = false
}

async function refetchData(targetPeriod: period) {
  if (userPermission.getUserPermission.read_action.includes(moduleName.CIRCLE_ANALYTIC)) {
    periodState.value = targetPeriod
    fetchState.dataSorted = false
    sortableCount = 2
    chartData.labels = []
    chartData.circleDataNonUser.data = []
    chartData.circleDataUser.data = []
    periodCounter.value = 0
    // await fetchTotalViewSignedInUserForResearch(periodState.value)
    // await fetchTotalViewNonUserForResearch(periodState.value)
    fetchTotalViewSignedInUserForinstitution(periodState.value)
    fetchTotalViewNonUserForinstitution(periodState.value)
  }
}

// const totalViewResearchLabel = computed(()=>totalViewMergedResearch.value.map(item=>item.target_date.toString()))
// const totalViewResearchData = computed(()=>totalViewMergedResearch.value.map(item=>item.total))
// const totalViewCircleLabel = computed(()=>totalViewMergedCircle.value.map(item=>item.target_date.toString()))
// const totalViewresearchDataNonUser = computed(()=>totalViewMergedCircle.value.map(item=>item.total))

onMounted(async ()=> {
  // await fetchTotalViewSignedInUserForResearchInSevenDaysBack()
  // await fetchTotalViewNonUserForResearchInSevenDaysBack()
  if (userPermission.getUserPermission.read_action.includes(moduleName.CIRCLE_ANALYTIC)) {
    refetchData(periodState.value)
  }
})
</script>
<template>
  <div class="flex flex-col bg-white border-[1px] rounded-[6px] p-[16px] gap-[16px]" v-show="userPermission.getUserPermission.read_action.includes(moduleName.CIRCLE_ANALYTIC)" >
      <div class="flex fex-row items-center">
      <div class="text-[20px] font-bold flex-grow">Total View Circle</div>
      <div class="w-[16px] h-[16px]">
      </div>
      </div>
      <div class="flex fex-row items-center">
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.SEVENDAY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.SEVENDAY)">Last 7 days</button>
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.MONTHLY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.MONTHLY)">Monthly</button>
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.YEARLY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.YEARLY)">Yearly</button>
      </div>
      <div class="w-full my-[8px]">
      <BarChart v-if="fetchState.dataSorted && (chartData.circleDataNonUser.data.length > 0 || chartData.circleDataUser.data.length > 0)" id="chartViewCircle" :labels="compiledLabel" :datasets="[chartData.circleDataNonUser,chartData.circleDataUser]" />
      <div v-if="!fetchState.dataSorted" class="w-full h-[250px]">
        <linearLoadingCard />
      </div>
        <!-- <BarChart v-if="!fetchState.dataSorted" id="chartViewCircle" :labels="chartData.labels" :datasets="[chartData.circleDataNonUser,chartData.circleDataUser]" /> -->
      </div>
  </div>
</template>